const NumberFormats = (numbers) => {
    var numberzone = 'en-US';
    var numberoption = '{"style": "decimal"}';
    var resNumberFormat = new Intl.NumberFormat(numberzone, JSON.parse(numberoption)).format(numbers);
    return resNumberFormat;
}
export default NumberFormats;